import { InfoSvg } from '../wf-svg';

import './index.scss';

interface WfErrorProps {
  error: boolean;
  t: (key: string) => string;
}

function WfError(props: WfErrorProps) {
  const { error, t } = props;

  const submitErrorClassName = `wf-error ${error ? 'wf-error_show' : ''}`;

  return (
    <div className={submitErrorClassName}>
      <InfoSvg className="wf-error-icon" />
      <p className="wf-error-msg">{t('webform.submit_request.title.error')}</p>
    </div>
  );
}

export default WfError;
